import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CameraIcon, GalleryIcon } from '@common-fe/common-fe';

import { FileImage } from '@/common/constants';
import { FileGetAndUploadButton } from '@/components/controls/DropScan/FileGetAndUploadButton/FileGetAndUploadButton';
import prepareFile from '@/components/controls/DropScan/prepareFile';
import { DocumentTypesEnum } from '@/modules/MyDocuments/myDocuments.types';
import UploadFileByLinkHeader from '@/modules/transaction/components/UploadFileByLink/UploadFileByLinkHeader';

import { UploadFileByQrLinkAppLinksPopup } from './UploadFileByQrLinkAppLinksPopup';
import { Step } from './uploadQrFile.types';

const BUTTON_WIDTH = '320px';

interface Props {
  setStep: (step: Step) => void;
  isPopupAvailable?: boolean;
  setIsPopupAvailable?: (isPopupAvailable: boolean) => void;
  documentType?: DocumentTypesEnum | null;
  uploadFile: (file: FileImage) => Promise<FileImage & { canceled: boolean } | undefined>;
}

export const UploadFileByQrLinkProcess: React.FC<Props> = ({
  setStep,
  isPopupAvailable = true,
  setIsPopupAvailable,
  documentType,
  uploadFile,
}) => {
  const { t } = useTranslation();
  const [popupVisible, setPopupVisible] = useState(isPopupAvailable);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleCapture = async (target: any) => {
    setStep(Step.LOADING);
    if (target.files) {
      if (target.files.length !== 0) {
        const file = prepareFile(target.files[0]);
        const response = await uploadFile(file);

        if (response?.canceled) {
          setStep(Step.PROCESS);
          return;
        }

        if (!response) {
          setStep(Step.ERROR);
          return;
        }

        if (response) {
          setTimeout(() => {
            setStep(Step.SUCCESS);
          }, 2000);
        }
      }
    }
  };

  return (
    <Box height={{ min: '100svh' }}>
      <UploadFileByLinkHeader
        title={
          documentType === DocumentTypesEnum.LETTER_OF_MEDICAL_NECESSITY
            ? t('Letter of Medical Necessity')
            : t('Reimburse Me')
        }
      />
      <Box
        width="100%"
        align="center"
        margin={{ top: '-24px' }}
        gap="spacing12"
        style={{ position: 'relative' }}
      >
        <Box width={BUTTON_WIDTH}>
          <FileGetAndUploadButton
            onChange={(e) => handleCapture(e.target)}
            title={t('Use Camera')}
            id="Camera"
            cameraInput
            icon={<CameraIcon color="canvas" />}
            isRightIconPosition
          />
        </Box>
        <Box width={BUTTON_WIDTH}>
          <FileGetAndUploadButton
            onChange={(e) => handleCapture(e.target)}
            title={t('Select From Gallery')}
            id="Gallery"
            secondary
            icon={<GalleryIcon color="iconPrimary" />}
            isRightIconPosition
          />
        </Box>
      </Box>

      <UploadFileByQrLinkAppLinksPopup
        visible={popupVisible}
        setVisible={setPopupVisible}
        setPopupAvailable={setIsPopupAvailable}
      />
    </Box>
  );
};
